import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import React, { Fragment } from "react";
import Button from "@mui/material/Button";
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import SentimentNeutralIcon from '@mui/icons-material/SentimentNeutral';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import { secondsConversion, formatDate } from "../Utilities/UtilityMethods";
import Tooltip from "@mui/material/Tooltip";
import { CallRowViewModel } from "../ViewModels/IndexContainerViewModels";
import displayScorecardResult from "../Utilities/DisplayScorecardScore";
import TableContainer from "@mui/material/TableContainer";
import Box from "@mui/material/Box";

const styles = {
    tableCell: {
        padding: '4px 12px 4px 12px',
    },
}

interface IAgentViewTableProps {
    agentCallRows: CallRowViewModel[];
    handleFeedbackOpen(callRefId: string): void;
    handleChangePage: (event: unknown, newPage: number) => void;
    handleChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void;
    page: number;
    rowsPerPage: number;
    count: number;
}

export default function AgentViewTable(props: IAgentViewTableProps) {

    return (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <TableContainer style={{ height: '100%' }}>
                <Table stickyHeader style={{ overflowY: 'scroll' }}>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={styles.tableCell}>Time</TableCell>
                            <TableCell sx={styles.tableCell}>Call Length</TableCell>
                            <Tooltip title="Customer's sentiment at end of call" placement="top">
                                <TableCell sx={styles.tableCell} align="center">Sentiment</TableCell>
                            </Tooltip>
                            <TableCell sx={styles.tableCell}>Result</TableCell>
                            <TableCell sx={styles.tableCell}>Phone Number</TableCell>
                            <TableCell sx={styles.tableCell}>Customer ID</TableCell>
                            <TableCell sx={styles.tableCell}>Score</TableCell>
                            <TableCell sx={styles.tableCell}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.agentCallRows.length <= 0 &&
                            <TableRow>
                                <TableCell align="center" colSpan={15} sx={styles.tableCell}>No records found</TableCell>
                            </TableRow>
                        }
                        {props.agentCallRows.length > 0 && props.agentCallRows.map((row, index) =>
                            <TableRow key={index}>
                                <TableCell sx={styles.tableCell}>
                                    {formatDate(row.eventTime)}
                                    <br />
                                    {new Date(row.eventTime).toLocaleTimeString()}
                                </TableCell>
                                <TableCell sx={styles.tableCell}>{secondsConversion(row.callLength)}</TableCell>
                                <TableCell sx={styles.tableCell} align="center">
                                    {
                                        row.customerSentimentEnd ?
                                            (row.customerSentimentEnd >= -0.5 && row.customerSentimentEnd <= 0.5) ?
                                                <SentimentNeutralIcon fontSize="medium" sx={{ color: `#cccc00` }} />
                                                : row.customerSentimentEnd < -0.5 ?
                                                    <SentimentVeryDissatisfiedIcon fontSize="medium" sx={{ color: `red` }} />
                                                    : row.customerSentimentEnd > 0.5 ?
                                                        <SentimentVerySatisfiedIcon fontSize="medium" sx={{ color: `green` }} />
                                                        : <Fragment />
                                            :
                                            <Fragment />
                                    }
                                </TableCell>
                                <TableCell sx={styles.tableCell}>{row.result}</TableCell>
                                <TableCell sx={styles.tableCell}>{row.telephone}</TableCell>
                                <TableCell sx={styles.tableCell}>{row.customerID}</TableCell>
                                <TableCell sx={styles.tableCell}>{row.score !== null && displayScorecardResult(row.score)}</TableCell>
                                <TableCell align="right" sx={{ width: '210px', padding: '4px 12px 4px 12px' }}>
                                    <Button
                                        variant='contained'
                                        color='secondary'
                                        onClick={() => { props.handleFeedbackOpen(row.systemPK) }}>
                                        View
                                    </Button>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>

            </TableContainer>
            {
                props.agentCallRows.length > 0 &&
                <Grid container justifyContent="flex-end">
                    <Grid>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 20]}
                            component="div"
                            count={props.count}
                            rowsPerPage={props.rowsPerPage}
                            page={props.page}
                            onPageChange={props.handleChangePage}
                            onRowsPerPageChange={props.handleChangeRowsPerPage}
                        />
                    </Grid>
                </Grid>
            }
        </Box >
    );
}